import { useQuery } from "@apollo/client";
import { graphql } from "~/gql";

export const GET_BRAND_QUERY = graphql(/* GraphQL */ `
  query GetBrand($brandId: Float) {
    getBrand(id: $brandId) {
      ...BrandParts
    }
  }
`);

export function useBrandQuery(brandId: number | null) {
  return useQuery(GET_BRAND_QUERY, {
    variables: {
      brandId,
    },
  });
}
